import { render, staticRenderFns } from "./balanceDialog.vue?vue&type=template&id=5603614b&"
import script from "./balanceDialog.vue?vue&type=script&lang=js&"
export * from "./balanceDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports